<div class="flex-column fullheight-noscroll" form-collector #orderLabels="collector" style="max-width: 300px;">
    <h2 class="modal-title" style="word-wrap: break-word; overflow-wrap: break-word; white-space: normal;">
        <span *ngIf="is_edit_form">{{ 'LABEL.FLAG.EDIT' | trans : label_flag.name }}</span>
        <span *ngIf="!is_edit_form">{{ 'LABEL.FLAG' | trans }}</span>
    </h2>

    <p style="font-size: 95%; text-align: end; color: rgb(var(--warn));"><span
            style="animation: blink 1s infinite forwards;">*</span>&nbsp; {{"REQUIRED_FILEDS" | trans }}</p>

    <div style="overflow: auto; ">
        <div class="flex-column">
            <label class="input outlined" title="{{ 'LABEL.FLAG.SHORT.NAME' | trans }}">
                <i icon="short_text"></i>
                <input style="padding-left: 2px;" required placeholder="{{ 'LABEL.FLAG.SHORT.NAME' | trans }}" [(ngModel)]="label_flag.short_name" conditions="nonempty" />
            </label>

            <label class="input outlined" title="{{ 'LABEL.FLAG.LONG.NAME' | trans }}">
                <i icon="text_fields"></i>
                <input style="padding-left: 2px;" required placeholder="{{ 'LABEL.FLAG.LONG.NAME' | trans }}" [(ngModel)]="label_flag.name" conditions="nonempty" />
            </label>

            @if (is_sys_admin) {
                <knw-auto-search  
                    required
                    [function]="search_companies" 
                    [to-label]="format_company_name"
                    label="{{'COMPANY' | trans }}" 
                    [(ngModel)]="picked_company" 
                    [popover-width]="'auto'"
                    [classes]="'span-cols-full outlined mx-0'" 
                    (ngModelChange)="company_picker_change()">
                </knw-auto-search>   
            }

            <div class="flex-row align-center wrappable" style="margin-top: 1em;">
                <label class="checkbox-input">
                    <input type="checkbox" [(ngModel)]="label_flag.orders" />
                    {{"LABEL.FLAG.ORDER" | trans }}
                </label>
                <label class="checkbox-input">
                    <input type="checkbox" [(ngModel)]="label_flag.scheduled_orders"/>
                    {{"LABEL.FLAG.SCHEDULE.ORDER" | trans }}
                </label>
                <label class="checkbox-input">
                    <input type="checkbox" [(ngModel)]="label_flag.tickets" />
                    {{"LABEL.FLAG.TICKET" | trans }}
                </label>
            
                <label class="checkbox-input">
                    <input type="checkbox" [(ngModel)]="label_flag.supplier_visible" />
                    {{"LABEL.FLAG.SUPPLIER" | trans }}
                </label>
        </div>
    </div>

    <div class="flex-row modal-footer">
        <button color="primary" (click)="cancel()">
            <i icon="clear"></i>
            {{ 'CANCEL' | trans }}
        </button>

        <button [disabled]="orderLabels.containsErrors()" class="filled" color="secondary" (click)="done()">
            <i icon="check"></i>
            {{ 'SAVE' | trans }}
        </button>
    </div>
</div>